import { movies } from "@/mocks/movies";
import { novels } from "@/mocks/novels";
import { news } from "@/mocks/news";
import { slides } from "@/mocks/slides";
import type { Movie, Novel, News, Slide } from "@/types";

export const allMovies = movies as Movie[];
export const allNovels = novels as Novel[];
export const allNews = news as News[];
export const allSlides = slides as Slide[];

export function getMovieById(id: string): Movie | undefined {
  return allMovies.find((item) => item.id === id);
}

export function getNovelById(id: string): Novel | undefined {
  return allNovels.find((item) => item.id === id);
}

export function getNewsById(id: string): News | undefined {
  return allNews.find((item) => item.id === id);
}

export function filterByField<T>(list: T[], field: keyof T, value: string): T[] {
  if (!value || value === "全部") return list;
  return list.filter((item) => (item[field] as unknown as string) === value);
}

export function uniqueValues<T>(list: T[], field: keyof T): string[] {
  const set = new Set<string>();
  list.forEach((item) => set.add(item[field] as unknown as string));
  return Array.from(set);
}

export function paginate<T>(list: T[], page: number, pageSize: number): T[] {
  const start = (page - 1) * pageSize;
  return list.slice(start, start + pageSize);
}

export function formatWordCount(count: number): string {
  if (count >= 10000) {
    return `${(count / 10000).toFixed(1)}万字`;
  }
  return `${count}字`;
}

export function searchCatalog(keyword: string) {
  const kw = keyword.trim().toLowerCase();
  if (!kw) {
    return { movies: [] as Movie[], novels: [] as Novel[], news: [] as News[], total: 0 };
  }
  const matchedMovies = allMovies.filter(
    (m) =>
      m.title.toLowerCase().includes(kw) ||
      m.subtitle.toLowerCase().includes(kw) ||
      m.genre.toLowerCase().includes(kw) ||
      m.director.toLowerCase().includes(kw) ||
      m.summary.toLowerCase().includes(kw) ||
      m.tags.some((t) => t.toLowerCase().includes(kw))
  );
  const matchedNovels = allNovels.filter(
    (n) =>
      n.title.toLowerCase().includes(kw) ||
      n.author.toLowerCase().includes(kw) ||
      n.genre.toLowerCase().includes(kw) ||
      n.summary.toLowerCase().includes(kw) ||
      n.tags.some((t) => t.toLowerCase().includes(kw))
  );
  const matchedNews = allNews.filter(
    (n) =>
      n.title.toLowerCase().includes(kw) ||
      n.channel.toLowerCase().includes(kw) ||
      n.summary.toLowerCase().includes(kw) ||
      n.tags.some((t) => t.toLowerCase().includes(kw))
  );
  return {
    movies: matchedMovies,
    novels: matchedNovels,
    news: matchedNews,
    total: matchedMovies.length + matchedNovels.length + matchedNews.length,
  };
}